import React from 'react'
import { IElementProps } from '../../../types/interfaces'
const CheckBox = (props: IElementProps) => {
  const handleValueChange = (value: string) => {
    const e = {
      target: {
        value,
      },
    } as React.ChangeEvent<HTMLInputElement>

    props.handleChange(props.name, e)
  }

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="control-group checkbox">
            <label className="control control-checkbox">
              {props.label}
              {props.translatedTooltip && (
                <>
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </>
              )}
              <input
                disabled={props.formReadOnly || props.disabledInput}
                type="checkbox"
                placeholder={props.label}
                checked={props.value === 'true' ? true : false}
                onChange={(e) => {
                  handleValueChange(e.target.checked ? 'true' : 'false')
                }}
              />
              <div className="control_indicator required-highlight" />
            </label>
          </div>
        </div>
      )}
    </>
  )
}
export default CheckBox
